<template>
	<div class="pick-list-box">
		<div class="top-header">
			<el-button size="mini" type="primary" v-print="'#printTest'">{{ $t('other.a342') }}</el-button>
		</div>
		<div id="printTest">
			<div>
				<div class="pick-list-wrpper">
					<div class="print-area" v-if="stocklist.length">
						<div style="display: flex;justify-content: space-between;">
							<div style="margin-bottom: 20px;">
								<div style="display: flex;justify-content: space-between;">
									<h2>{{ $t('other.a939') }}</h2>
								</div>
								<div style="font-size: 14px;font-weight: bold;padding-top: 16px;">Total: {{ amount }}</div>
								<div style="font-size: 14px;font-weight: bold;padding-top: 15px;">{{ nowTime }}</div>
							</div>
							<!-- <div style="width: 200px;">
							 	<img v-show="flage == 0" style="width: 100%;" src="../../../../assets/img/pic/id-01.png" />
								 <img v-show="flage == 1" style="width: 100%;" src="../../../../assets/img/lazada-title.png" />
							 </div> -->
						</div>
						<div
							style="display: flex;justify-content: flex-start;border-bottom: 1px solid #000;font-weight: bold;text-align: center;">
							<span style="display: inline-block;width: 40px;font-size: 16px;padding: 0px 5px;">#</span>
							<span style="font-size: 18px;display: inline-block;width: 115px;padding: 0px 5px;">Order
								NO.</span>
							<span style="font-size: 18px;display: inline-block;width: 120px;padding: 0px 5px;">Img</span>

							<span
								style="display: inline-block;width: 125px;font-size: 16px;padding: 0px 5px;">Cuscode</span>
							<span style="display: inline-block;width: 125px;font-size: 16px;padding: 0px 5px;">W Sku</span>
							<span
								style="display: inline-block;width: 119px;font-size: 16px;padding: 0px 5px;">Position</span>
							<span style="font-size: 18px;flex: 1;text-align: center;padding: 0px 5px;">Qty</span>
						</div>
						<div style="display: flex;align-items: center;padding-bottom: 10px;border-bottom: 1px solid #000;text-align: center;padding-top: 10px;"
							v-for="(item, index) in stocklist">
							<div class="desc-item" style="width: 40px;">{{ index + 1 }}</div>
							<div class="desc-item-name" style="width: 115px;">{{ item.orderId }}</div>
							<div class="pic-box" style="width: 120px;"><img
									style="width: 100%;display: block;margin: 0 auto;" :src='item.image' /></div>

							<div class="desc-item-copy" style="width: 125px;">{{ item.cusCode }}</div>
							<div class="desc-item-copy" style="width: 119px;">{{ item.skuName }}</div>
							<div class="desc-item-copy" style="width: 119px;">{{ item.address }}</div>
							<div class="desc-item-copy-1"
								style="font-size: 18px;text-align: center;flex: 1;">{{ item.qty }}</div>
						</div>
					</div>

				</div>

			</div>
		</div>
	</div>
</template>

<script>
import utils from '../../../../utils/utils'
import newOrderApi from '@/api/moudles/newOrders'
import {
	mapState,
	mapActions,
} from 'vuex'
import json2csv from 'json2csv'
import csvExportor from "csv-export";
export default {
	data() {
		return {
			stocklist: [],
			nowTime: '',
			total: 0,
			amount: 0,
			stocklistCopy: [],
			hasStoreItem: [],
			flage: 0

		}
	},
	computed: {
		...mapState({
			seller: state => state.login.userInfo.userId
		}),


	},
	created() {
		this.getOrdersByOrderId()
		// this.init()
		this.getNowTime()
	},

	methods: {

		getOrdersByOrderId() {
			this.flage = this.$route.query.flag
			let list = JSON.parse(localStorage.getItem('stockingInfoCopy'))
			newOrderApi
				.getOrderPDF(list)
				.then(res => {
					if (res.code === 200) {
						console.log('desc', res.data)
						res.data.forEach(p => {
							p.items.forEach(k => {
								if (k.storeItem && k.storeItem.component) {
									k.storeItem.orderId = p.orderId
									k.storeItem.purchaseQty = k.variationQuantityPurchased
									this.hasStoreItem.push(k.storeItem)
								}
								if (k.storeItem && !k.storeItem.component && k.storeItem.children) {
									k.storeItem.children.forEach(i => {
										i.orderId = p.orderId
										i.purchaseQty = k.variationQuantityPurchased
										this.hasStoreItem.push(i)
									})
								}
								if (!k.storeItem) {
									k.cusCode = null
									this.hasStoreItem.push(k)
								}

							})
						})

						console.log('hasStoreItem', this.hasStoreItem)
						if (this.hasStoreItem) {
							this.init()
						}

					} else {
						this.$message.warning(res.msg)
					}
				})

		},

		//获取当前时间
		getNowTime() {
			let time = new Date()
			let timeCopy = utils.getCurrnetTime(time)
			this.nowTime = timeCopy
			console.log(timeCopy)
		},
		init() {
			let listMap = new Map()
			this.hasStoreItem.forEach(p => {
				let list = listMap.get(p.cusCode)
				if (!list || list == undefined) {
					list = []
				}
				list.push(p)
				listMap.set(p.cusCode, list)
			})
			let list = []
			listMap.forEach((value, key) => {
				list.push({
					cusCode: key,
					list: value
				})
			})

			list.forEach(p => {
				console.log(p)
				p.orderId = p.list[0].orderId
				p.itemName = p.list[0].itemName
				p.image = p.list[0].image
				p.address = p.list[0].address
				p.skuName = p.list[0].skuName
				p.qty = 0
				p.list.forEach(i => {
					if (i.itemName == 'Empty gift') {
						p.cusCode = 'Empty gift'
						p.skuName = 'Empty gift'
						p.cusCode = 'Empty gift'
						p.qty = 0
					}
					i.rate = i.rate == 0 ? 1 : i.rate
					p.qty += i.purchaseQty * i.rate
				})
				this.amount += p.qty
			})

			this.stocklist = list




			console.log('list', list)
			console.log('listMap', listMap)
		}
	}


}
</script>

<style>
.pick-list-box {
	width: 100%;
	background: #fff;
	z-index: 99999;
	position: absolute;

}

.top-header {
	position: relative;
	width: 800px;
	text-align: right;
	margin: 0 auto;


}

.pp-wrapper {
	display: flex;

	align-items: center;
}

.pp-name {
	display: inline-block;
	width: 300px !important;
}

.ttp-box {
	margin-bottom: 60px;
	border: 1px solid #000;
}

.pick-list-wrpper {
	width: 100%;
	display: flex;
	justify-content: center;
	font-size: 12px;
	box-sizing: border-box;
	margin: 0 10px;
}

.print-area {
	width: 210mm;
	height: 100%;
	margin-bottom: 200px;
	box-sizing: border-box;
	padding: 30px;
}

.print-desc {
	display: flex;
	flex: 1;

}

.desc-item {
	font-size: 18px;
	/* font-weight: bold; */
	width: 100px;
	word-wrap: break-word;
	padding: 0px 5px;


}

.desc-item-copy {
	font-size: 18px;
	/* font-weight: bold; */
	width: 90px;
	word-wrap: break-word;
	/* margin: 0 20px 0 15px; */
	padding: 0px 5px;


}

.desc-item:nth-child(1) {
	font-size: 18px;
	width: 30px;
}

.desc-item:nth-child(3) {
	font-size: 14px;
	width: 600px;
}

.desc-item-ttp {
	display: inline-block;
	width: 186px;
}

.desc-item-oop {
	display: inline-block;


}

.desc-item-bottom {
	padding: 5px 0;
	border-bottom: 1px solid #DCDFE6
}

.desc-item-bottom:nth-last-child(1) {
	padding: 5px 0;
	border-bottom: none
}



.desc-item-name {
	width: 120px;
	padding: 0px 5px;
	/* font-weight: bold; */
	font-size: 18px;
	word-break: break-all;
	overflow-wrap: break-word;
}

.pic-box {
	width: 120px;
	min-height: 150px;
	/* height: 50px; */
	/* margin: 0 5px; */
}</style>
